export default __webpack_public_path__ + "static/media/img_20.d06da6f0.jpg";